import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IAttendeesDAO } from '../../../../api/attendees.dao';

export class GenerateOrganizationLinksJob extends JobConfiguration {
    public readonly type = JobType.GenerateOrganizationsLinks;
    public readonly name = 'Generate Presenter Org Links';
    public readonly description = 'Organization Links Generation';

    public async execute(execParams) {
        return IoC.Container.get(IAttendeesDAO).generateOrganizationsLinks(execParams);
    }
}

export default {
    [JobType.GenerateOrganizationsLinks]: GenerateOrganizationLinksJob
};
